import { StoreApi } from 'zustand';
import { TableState } from '@store/table-store/table.model.ts';
import { CallStateEnum } from '@shared/models/call-state.model';
import { HandleClose } from '@models/dialog.model.ts';
import { CallStateMethods } from '@shared/store-features/call-state-feature';
import { DigitalSignageScreensModel } from '@modules/digital-signage/model/screens.model.ts';
import {
  PlaylistModel,
  PlaylistScreenOption
} from '@modules/digital-signage/model/playlists.model.ts';
import {
  DeviceGroupDeviceModel,
  DeviceGroupModel,
  DeviceGroupReqModel
} from '@models/digital-signage/device-groups.model.ts';
import {
  DeviceGroupScheduleModel,
  DeviceGroupScheduleReqModel
} from '@models/digital-signage/device-group-schedules.model.ts';

export interface EditGroupSettingsParams {
  id?: string;
  body: DeviceGroupReqModel;
  state?: TableState;
  handleClose?: HandleClose;
  onSuccess?: () => void;
}

export interface DeleteGroupParams {
  id: string;
  state?: TableState;
  handleClose?: HandleClose;
  onSuccess?: () => void;
}

export interface SaveLocalScheduleParams {
  id?: string;
  body: DeviceGroupScheduleReqModel;
}

export interface GroupSettingsData {
  callState: CallStateEnum;
  screensCallState: CallStateEnum;
  playlistsCallState: CallStateEnum;
  groupDetailsCallState: CallStateEnum;
  devicesCallState: CallStateEnum;
  deviceGroupsCallState: CallStateEnum;
  groupDetails: DeviceGroupModel | null;
  devicesList: DeviceGroupDeviceModel[];
  deviceGroupsList: DeviceGroupModel[];
  devicesOptions: PlaylistScreenOption[];
  screensList: DigitalSignageScreensModel[];
  playlistsList: PlaylistModel[];
  screensOptions: PlaylistScreenOption[];
  playlistsOptions: PlaylistScreenOption[];
  schedules: DeviceGroupScheduleModel[];
  savedSchedules: DeviceGroupScheduleModel[];
}

export interface GroupSettingsActions {
  getScreensOptions: () => Promise<void>;
  getPlaylistsOptions: () => Promise<void>;
  getGroupDetails: (id: string) => Promise<void>;
  getDevicesOptions: () => Promise<void>;
  getDeviceGroupsList: () => Promise<void>;
  editGroupSettings: (params: EditGroupSettingsParams) => void;
  reloadGroupDevices: (ids: string[]) => Promise<void>;
  deleteGroup: (params: DeleteGroupParams) => Promise<void>;
  resetGroupDevices: () => void;
  isScreensLoading: () => boolean;
  isPlaylistsLoading: () => boolean;
  isDevicesLoading: () => boolean;
  initSchedules: (schedules: DeviceGroupScheduleModel[]) => void;
  saveLocalSchedule: (params: SaveLocalScheduleParams) => void;
  removeLocalSchedule: (id: string) => void;
  resetSchedules: () => void;
}

export type GroupSettingsState = GroupSettingsData &
  GroupSettingsActions &
  CallStateMethods;

export type GroupSettingsSet = StoreApi<GroupSettingsState>['setState'];
export type GroupSettingsGet = StoreApi<GroupSettingsState>['getState'];

export const GROUP_SETTINGS_INITIAL_STATE: GroupSettingsData = {
  callState: CallStateEnum.Init,
  screensCallState: CallStateEnum.Init,
  playlistsCallState: CallStateEnum.Init,
  groupDetailsCallState: CallStateEnum.Init,
  devicesCallState: CallStateEnum.Init,
  deviceGroupsCallState: CallStateEnum.Init,
  groupDetails: null,
  devicesList: [],
  deviceGroupsList: [],
  devicesOptions: [],
  screensList: [],
  playlistsList: [],
  screensOptions: [],
  playlistsOptions: [],
  schedules: [],
  savedSchedules: []
};
